import './App.css'
import Navbar from './containers/navbar/Navbar'
import Header from './containers/header/Header'
import Projects from './containers/projects/Projects'
import Summary from './components/summary/Summary'
import Qualifications from './containers/qualifications/Qualifications'
import Contact from './containers/contact/Contact'
import Footer from './components/footer/Footer'

const App = () => {
  return (
    <div className="app">
      <Navbar />
      <Header />
      <main className="mid-section">
        <Summary />
        <Qualifications />
        <Projects />
      </main>
      <Contact />
      <Footer />
    </div>
  )
}

export default App